import { S3_BUCKET_URL } from '@/constants';

import { EmailScreen } from './screens/Email';
import { FirstImpressionScreen } from './screens/FirstImpression';
import { GreetingScreen } from './screens/Greeting';
import { NameScreen } from './screens/Name';
import { PersonalScreen } from './screens/Personal';
import { PoolsideScreen } from './screens/Poolside';
import { SecurityScreen } from './screens/Security';
import { SettingUpProfileScreen } from './screens/SettingUpProfile';
import { ScreenWelcome } from './screens/Welcome';
import { LayoutDataType } from './types';

const ASSETS_PATH = `${S3_BUCKET_URL}/layout-own-ai-pool`;
const PAYWALL_IMAGE = `${S3_BUCKET_URL}/paywall/pool-girl/paywall.png`;

export const layoutSteps = {
  welcome: {
    component: ScreenWelcome,
    images: [],
  },
  first_impression: {
    component: FirstImpressionScreen,
    images: [`${ASSETS_PATH}/first-impression/background.jpg`],
  },
  greeting: {
    component: GreetingScreen,
    images: [`${ASSETS_PATH}/greeting/background.jpg`],
  },
  poolside: {
    component: PoolsideScreen,
    images: [`${ASSETS_PATH}/poolside/background.jpg`],
  },
  name: {
    component: NameScreen,
    images: [`${ASSETS_PATH}/name/background.jpg`],
  },
  personal: {
    component: PersonalScreen,
    images: [`${ASSETS_PATH}/personal/background.jpg`],
  },
  security: {
    component: SecurityScreen,
    images: [],
  },
  email: {
    component: EmailScreen,
    images: [],
  },
  setting_up_profile: {
    component: SettingUpProfileScreen,
    images: [PAYWALL_IMAGE],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  first_impression: null,
  greeting: null,
  poolside: null,
  personal: null,
  name: '',
  email: '',
};
